import { Button } from "@/components/ui/button";

const ContactSection = () => {
  return (
    <section className="py-48 px-4 bg-card">
      <div className="max-w-4xl mx-auto">
        {/* 左にズラした配置 */}
        <div className="w-[70%] md:w-[50%] ml-0 md:ml-16 space-y-12">
          <p className="text-sm text-muted-foreground font-light text-left">
            返信はゆっくりになります。気楽にどうぞ。
          </p>
          
          <div className="ml-4">
            <Button
              variant="outline"
              size="lg"
              className="border-border hover:bg-primary/10 hover:border-primary transition-colors duration-300"
              asChild
            >
              <a
                href="https://x.com/awijirun?s=21&t=fSHJ9CenI6va24cOV6FasQ"
                target="_blank"
                rel="noopener noreferrer"
              >
                そっと相談してみる
              </a>
            </Button>
          </div>
        </div>
        
        {/* 装飾 - 右下の斜め線 */}
        <div className="flex justify-end mt-24 mr-12">
          <div className="w-px h-12 bg-border/30 transform rotate-45" />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;